import Navbar from "../../../components/Navbar/Navbar";
import CreateLabRequestForm from "../components/CreateLabRequestForm.tsx/CreateLabRequestForm";

export default function CreateLabRequestPage() {
    return (
        <>
            <Navbar title="Create Lab Request" />
            <div className="page">
                <CreateLabRequestForm />
            </div>
        </>
    );
}
